import Vue from "vue";
import Router from "vue-router";
import Top from "./src/components/Top.vue";
import About from "./src/components/About.vue";
import Company from "./src/components/Company.vue";
import Business from "./src/components/Business.vue";
import Contact from "./src/components/Contact.vue";
import NotFound from "./src/components/NotFound.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "top",
    component: Top,
    meta: {
      title: "ゲリラスペース | トップページ",
      desc: "お客様の新規事業/業界改革をサポートするゲリラ戦特化企業です。",
      keywords:
        "ゲリラスペース,Guerrilla Space,新規事業,共創開発,新規サービス,クラウド,無料相談",
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta: {
      title: "ゲリラスペースとは？ - Guerrilla Space 株式会社ゲリラスペース",
      desc: "株式会社ゲリラスペースがなぜ立ち上がったのかを掲載しております！",
      keywords: "ゲリラスペース,Guerrilla Space,紹介,なぜ",
    },
  },
  {
    path: "/company",
    name: "company",
    component: Company,
    meta: {
      title: "ゲリラスペース会社情報 - Guerrilla Space 株式会社ゲリラスペース",
      desc: "株式会社ゲリラスペースの概要情報を掲載しております。",
      keywords:
        "ゲリラスペース,Guerrilla Space,会社情報,ミッション,ビジョン,バリュー",
    },
  },
  {
    path: "/business",
    name: "business",
    component: Business,
    meta: {
      title: "ゲリラスペース事業概要 - Guerrilla Space 株式会社ゲリラスペース",
      desc: "株式会社ゲリラスペースの事業情報を掲載しております。",
      keywords:
        "ゲリラスペース,Guerrilla Space,事業情報,相談方法,新規事業,スタートアップ支援",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
    meta: {
      title:
        "ゲリラスペースお問い合わせ - Guerrilla Space 株式会社ゲリラスペース",
      desc: "ゲリラスペースのお問い合わせページです。",
      keywords: "ゲリラスペース,Guerrilla Space,事業情報,相談,お問い合わせ",
    },
  },
  { path: "/*", component: NotFound },
];

export default new Router({
  mode: "history",
  routes: routes,
});
